<script setup lang="ts">
import DataLoading from '@/components/data-loading/data-loading.vue'
import { useZendeskAuthSync } from '@/composables/useZendeskWidget'
import Navigation from '@/layout/app/navigation.vue'
import { appLoadError, retryRouteLoad, useKeepRouteDataAlive } from '@/lib/appLoad'
import { router } from '@/router'
import { LToastProvider } from '@repo/lui'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useHead } from '@unhead/vue'
import { computed, ref } from 'vue'

const isDevDomain = window.location.hostname.includes('lykadev.com.au')
const zendeskAllowedHost = import.meta.env.DEV || isDevDomain

const isRouteReady = ref(false)
router.isReady().then(() => {
  isRouteReady.value = true
})
const isReady = computed(() => isRouteReady.value && !appLoadError.value)

useKeepRouteDataAlive()
useZendeskAuthSync({ allowedHost: zendeskAllowedHost })

useHead({
  titleTemplate: '%s - Lyka account',
  meta: isDevDomain ? [{ name: 'robots', content: 'noindex, nofollow' }] : [],
})
</script>

<template>
  <LToastProvider position="bottom-center" />

  <div class="flex min-h-dvh flex-col-reverse md:flex-col">
    <Navigation />

    <main class="flex grow flex-col">
      <DataLoading
        v-if="!isReady"
        :loading="!isRouteReady"
        :error="appLoadError"
        full-page
        variant="spinner"
        @try-again="retryRouteLoad"
      />

      <router-view v-else v-slot="{ Component }">
        <component :is="Component" ref="mainContent" />
      </router-view>

      <VueQueryDevtools v-if="false" />
    </main>
  </div>
</template>
